import { AutoPayFundingSourceScreen } from '@/src/experiences/card-payments/screens/AutoPayFundingSource'
export default AutoPayFundingSourceScreen.Screen
